import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { useCompanySettings } from "@/hooks/use-company-settings";
import { CompanyInformationCard } from "./CompanyInformationCard";

export function AccountSettings() {
  // Get current user from auth hook
  const { user } = useAuth();
  
  // Check if user is an admin
  const isAdmin = user?.role === 'admin' || user?.role === 'owner';
  
  // Get company settings state and logic from custom hook
  const {
    company,
    isLoading,
    isEditing,
    formData,
    setFormData,
    handleSubmit,
    handleCancel,
    handleEdit,
    updateMutation,
  } = useCompanySettings(user?.companyId ?? undefined);

  // TODO: Add metric/logging if user has no company - this should never happen in production
  if (!user?.companyId) {
    console.error('[AccountSettings] User has no company - this should not happen');
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <CompanyInformationCard
        company={company}
        isEditing={isEditing}
        formData={formData}
        isPending={updateMutation.isPending}
        isAdmin={isAdmin}
        onFormDataChange={setFormData}
        onEdit={handleEdit}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </div>
  );
}
